import KendoDataSourceMixin from './KendoDataSourceMixin'

export default {
    name: 'kendo-datasource',
    mixins: [ KendoDataSourceMixin ]
}


// WEBPACK FOOTER //
// ./packages/kendo-datasource-vue-wrapper/src/KendoDataSource/index.js